import { Icon } from 'components/Icon/Icon';
import styles from './BackupReminder.module.scss'
import { faFileCircleInfo } from '@fortawesome/pro-solid-svg-icons'

const BackupReminder = () => (
    <div className={styles.container}>
        <div className={styles.header}><Icon icon={faFileCircleInfo} ></Icon>REVIEW DOCUMENTATION</div>
        <div className={styles.content}>Please review the backup documentation before creating a dispute.</div>
    </div>
)


export default BackupReminder;